var exports = {
  "az": "Box__8KUBIb",
  "EY": "Text__i00JO1",
  "ou": "Token__EWMxcq",
  "wy": "Box_1__7hzibG",
  "m4": "Octicon__t3iLcQ",
  "$n": "Button__IzQ74q",
};

module.exports = exports;
